import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import {
  clearBacklink,
  setActiveSection,
  setBackLink,
} from '@redux/site/siteSlice'
import { Tabs } from '@components/Tabs/Tabs'
import { Outlet } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'

export const PermissionSets = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(
      setBackLink({
        title: 'permission sets list',
        href: `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_PERMISSION_SETS_LIST}`,
      }),
    )

    return () => {
      dispatch(clearBacklink())
    }
  })

  return (
    <>
      <Tabs
        data={[
          {
            label: 'Details',
            path: `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_PERMISSION_SETS}/${RoutePaths.ADMIN_SETTINGS_PERMISSION_SETS_DETAILS}`,
          },
          {
            label: 'Custom field visibility',
            path: `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_PERMISSION_SETS}/${RoutePaths.ADMIN_SETTINGS_PERMISSION_SETS_CUSTOM_FIELD_VISIBILITY}`,
          },
          {
            label: 'Staff',
            unviewed: 1,
            path: `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_PERMISSION_SETS}/${RoutePaths.ADMIN_SETTINGS_PERMISSION_SETS_STAFF}`,
          },
        ]}
      />
      <Outlet />
    </>
  )
}
